module.exports = "<div class=\"pdf-viewer\">\n  <div class=\"pdfobject-container\" id=\"pdf-container\"></div>\n</div>\n"